import { Button, FlexBox, Icon } from '@vp/swan'
import { useOpenCallMeWidget } from '@vp/care-react-c2c'
import { useTranslation } from 'react-i18next'

interface Props {
  tenant: string
  locale: string
}
export const CallMeButton = (props: Props) => {
  const { tenant, locale } = props
  const { t } = useTranslation(tenant)
  const lng = locale.toLowerCase().replace('-', '_')
  return (
    <Button
      id="call_me_button_online"
      style={{ display: 'block', cursor: 'pointer' }}
      onClick={useOpenCallMeWidget()}
      skin="secondary"
      type="button"
      name="call_me_now"
      value="call_me_now"
      iconPosition="left"
    >
      <FlexBox>
        <Icon mr={3} iconType="phone" />
        {t(`${tenant}:call_me.buttons.call_me_online.title`, { lng })}
      </FlexBox>
    </Button>
  )
}
